import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/SNAPSEED-QR-CODES.webp";
import { Helmet } from 'react-helmet';
import { LanguageContext } from "../LanguageContext";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, setLanguage } = useContext(LanguageContext);
  const [theme, setTheme] = useState("light");
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    localStorage.setItem("theme", newTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  // Auto close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Helmet>
          <link rel="preload" as="image" href={logo} />
        </Helmet>

        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Snapseed QR Logo" loading="lazy" width="100" height="50" />
          </Link>
        </div>

        <button
          className="hamburger"
          onClick={toggleMobileMenu}
          aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMobileMenuOpen}
        >
          <span className="visually-hidden">
            {isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          </span>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        <ul className={`navbar-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/collection">Snapseed QR Codes</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li>
            <select
              value={language}
              onChange={handleLanguageChange}
              aria-label="Select language"
            >
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </li>
          <li>
     
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
